import { computed, toValue } from "vue";
import { useAllGlobalVariables, useMutation } from "@/core/api/graphql/composables";
import { LoadCartAfterFirstTimeSignInDocument } from "@/core/api/graphql/types";

export function useLoadCartAfterFirstTimeSignInMutation() {
  return useMutation(
    LoadCartAfterFirstTimeSignInDocument,
    computed(() => {
      const { storeId, cultureName, currencyCode } = toValue(useAllGlobalVariables());
      return {
        variables: {
          command: {
            storeId,
            cultureName,
            currencyCode,
          },
        },
      };
    }),
  );
}
